/*
		粘贴信息的处理
*/

import $ from './dom-core.js';
import { replaceHtmlSymbol } from './util.js';
import { objForEach } from './util.js';

// 获取粘贴的纯文本
export function getPasteText(e) {
	const clipboardData =
		e.clipboardData || (e.originalEvent && e.originalEvent.clipboardData);
	let pasteText;
	if (clipboardData == null) {
		pasteText = window.clipboardData && window.clipboardData.getData('text');
	} else {
		pasteText = clipboardData.getData('text/plain');
	}

	return replaceHtmlSymbol(pasteText);
}

// 获取粘贴的html
export function getPasteHtml(e, filterStyle, ignoreImg) {
	const clipboardData =
		e.clipboardData || (e.originalEvent && e.originalEvent.clipboardData);
	let pasteText, pasteHtml;
	if (clipboardData == null) {
		pasteText = window.clipboardData && window.clipboardData.getData('text');
	} else {
		pasteText = clipboardData.getData('text/plain');
		pasteHtml = clipboardData.getData('text/html');

		const [start, end] = [
			pasteHtml.indexOf('<!--StartFragment-->'),
			pasteHtml.indexOf('<!--EndFragment-->'),
		]
		if (start !== -1 && end !== -1) {
			pasteHtml = pasteHtml.slice(start + 20, end - 1);
		}

		// const m = JSON.stringify(pasteHtml).match(/<!--StartFragment-->(.*?)<!--EndFragment-->/)

		// if (m) {
		// 	pasteHtml = m[1];
		// }

		console.log('from clipboard:', pasteHtml);
	}
	if (!pasteHtml && pasteText) {
		pasteHtml = '<p>' + replaceHtmlSymbol(pasteText) + '</p>';
	}
	if (!pasteHtml) {
		return;
	}
	// ------------modify--------------//
	if (pasteHtml.match('figure class="reference"')) {
		// ------------------存在引用模块，复制粘贴取消纯文本----------------------- //
		return pasteHtml;
	}
	// ------------modify--------------//

	// pasteHtml = `<html>
	// <body>
	// <!--StartFragment--><p style="margin: 10px 0px; padding: 0px; box-sizing: border-box; line-height: 1.5; word-break: break-all; white-space: pre-wrap; overflow-wrap: break-word; color: rgb(0, 0, 0); font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", Arial, sans-serif; font-size: 14px; font-style: normal; font-variant-ligatures: normal; font-variant-caps: normal; font-weight: 400; letter-spacing: normal; orphans: 2; text-align: start; text-indent: 0px; text-transform: none; widows: 2; word-spacing: 0px; -webkit-text-stroke-width: 0px; text-decoration-thickness: initial; text-decoration-style: initial; text-decoration-color: initial;">阿斯顿发撒旦法阿斯顿发阿斯顿发阿斯顿发撒旦法按时到</p><p style="margin: 10px 0px; padding: 0px; box-sizing: border-box; line-height: 1.5; word-break: break-all; white-space: pre-wrap; overflow-wrap: break-word; color: rgb(0, 0, 0); font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", Arial, sans-serif; font-size: 14px; font-style: normal; font-variant-ligatures: normal; font-variant-caps: normal; font-weight: 400; letter-spacing: normal; orphans: 2; text-align: start; text-indent: 0px; text-transform: none; widows: 2; word-spacing: 0px; -webkit-text-stroke-width: 0px; text-decoration-thickness: initial; text-decoration-style: initial; text-decoration-color: initial;"> 阿斯顿发阿斯顿发阿斯顿发按时到撒旦法阿斯顿发</p><!--EndFragment-->
	// </body>
	// </html>`;

	// 过滤word中状态过来的无用字符
	const docSplitHtml = pasteHtml.split('</html>');
	if (docSplitHtml.length === 2) {
		pasteHtml = docSplitHtml[0];
	}

	// 过滤无用标签
	pasteHtml = pasteHtml.replace(/<(meta|script|link).+?>/gim, '');
	// 去掉注释
	pasteHtml = pasteHtml.replace(/<!--.*?-->/gm, '');
	// 过滤 data-xxx 属性
	pasteHtml = pasteHtml.replace(/\s?data-.+?=('|").+?('|")/gim, '');

	if (ignoreImg) {
		// 忽略图片
		pasteHtml = pasteHtml.replace(/<img.+?>/gim, '');
	}

	if (filterStyle) {
		// 过滤样式
		pasteHtml = pasteHtml.replace(/\s?(class|style)=('|").*?('|")/gim, '');
	} else {
		// 保留样式
		pasteHtml = pasteHtml.replace(/\s?class=('|").*?('|")/gim, '');
	}

	return pasteHtml;
}

// 获取粘贴的图片文件
export function getPasteImgs(e) {
	const result = [];
	const txt = getPasteText(e);
	if (txt) {
		// 有文字，就忽略图片
		return result;
	}

	const clipboardData =
		e.clipboardData || (e.originalEvent && e.originalEvent.clipboardData) || {};
	const items = clipboardData.items;
	if (!items) {
		return result;
	}

	objForEach(items, (key, value) => {
		const type = value.type;
		if (/image/i.test(type)) {
			result.push(value.getAsFile());
		}
	});

	return result;
}
